import React from 'react'
import { Field } from 'redux-form'
import InputField from 'forms/shared/fields/input'

const ChangePasswordFields = () => (
  <>
    <Field
      type="password"
      name={'oldPassword'}
      groupClassName="my-4"
      placeHolder="Old Password"
      inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName="text-action-danger text-xs slab"
      component={InputField}
    />
    <div className="mt-5">
      <p className="text-sm text-primary-dark">Input New Password:</p>
      <Field
        type="password"
        name={'newPassword'}
        groupClassName="my-4"
        placeHolder="New Password"
        inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
        inputGroupClassName=""
        inputErrorClassName="border-action-danger"
        errorClassName="text-action-danger text-xs slab"
        component={InputField}
      />
      <Field
        type="password"
        name={'newPasswordConfirmation'}
        groupClassName="my-4"
        placeHolder="Re-type New Password"
        inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
        inputGroupClassName=""
        inputErrorClassName="border-action-danger"
        errorClassName="text-action-danger text-xs slab"
        component={InputField}
      />
    </div>
  </>
)

export default ChangePasswordFields
